import { TileImgType } from "src/components/common/PolygonTile";

type ImageProps = {
  name: string;
  src: string;
  staticTile?: TileImgType;
  alt: string;
};

export const communitiesData: ImageProps[] = [
  {
    name: "MeetupJS Buenos Aires",
    src: "https://meetupjs.com.ar/_next/static/images/logo-3334efc6fdb5f577b4d3f8f3d0636bf4.svg",
    staticTile: "meetupJS",
    alt: "MeetupJS Buenos Aires",
  },
  {
    name: "Vuenos Aires Meetup",
    src: "https://secure.meetupstatic.com/photos/event/1/4/2/9/highres_463565161.jpeg",
    staticTile: "vuenosAires",
    alt: "Vuenos Aires Meetup",
  },
  {
    name: "BANode",
    src: "https://s3-alpha-sig.figma.com/img/7fac/c453/d6d1ebd5ef728a43cd758cab6285663f?Expires=1639958400&Signature=ZJ9~o0izLuroC8-f2Cf8qO99hyHpPZshPdPezsKX6anRmAdoikAWXsKoffZck2JR3MYRQJun1QfFgvyYvOzVFeqHO4dm2YlDKGADf~t-6JeY3weABaynXwMpm9KGcZs1bD9urOnnPhCaW~UHsD5r9yTouTdlkGlTO50P-au6GmmlwG1EQ-tVliDmAL2Sf8CCzUH8oFZ~xftqUtUjYIA~E8zBwskYZb21K0XAQ3DI4kFQTZrVYkl-sPRzxbriAnGC~qBbUKgl9q8XoEDfvnfxYsQgI0kuK0n7AlnAb7OhJJPbqzYL3~SmMN5JrnObVkF~ceHUEwy-Qpabs7ERF1Twmw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
    staticTile: "baNode",
    alt: "BANode",
  },
];
